module.exports = __webpack_public_path__ + "static/img/AB4338765.80ca371a.jpg";